import { ref, onMounted, onBeforeUnmount, unref } from 'vue';

export const useMouse = (elMaybeRef = window) => {
    const x = ref(0);
    const y = ref(0);

    const calcMousePos = (e) => {
        x.value = e.clientX;
        y.value = e.clientY;
    };

    onMounted(() => {
        const el = unref(elMaybeRef);
        if (!el) return;

        el.addEventListener('pointermove', calcMousePos, { passive: true });
    });

    onBeforeUnmount(() => {
        const el = unref(elMaybeRef);
        if (!el) return;

        el.removeEventListener('pointermove', calcMousePos, { passive: true });
    });

    return {
        x,
        y,
    };
};
